<template>
    <div class="FormImageCropUpload">
        <div class="input">
            <div
                v-if="!hidePreview"
                class="preview"
                :style="value ? `background-image: url(${value})` : ''"
                @click="$emit('click')"
            >
                <strong>Upload Image</strong>
            </div>
            <Button
                v-if="!hideSaveBtn && formData"
                class="primary"
                @click="$emit('save', formData)"
            >
                Save Image
            </Button>
        </div>

        <crop-upload
            v-if="show"
            ref="uploader"
            v-model="show"
            :width="300"
            :height="300"
            field="file"
            img-format="png"
            lang-type="en"
            @src-file-set="handleSrcFileSet"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
        />
    </div>
</template>

<script>
import myUpload from 'vue-image-crop-upload/upload-2.vue';

const DEFAULT_FILE = {
    name: 'image.png',
    type: 'image/png',
    size: 0,
};

export default {
    name: 'FormImageCropUpload',

    components: {
        'crop-upload': myUpload,
    },

    props: {
        value: { type: String },
        hidePreview: { type: Boolean, default: false },
        hideSaveBtn: { type: Boolean, default: false },
    },

    data: () => ({
        show: false,
        file: DEFAULT_FILE,
        imgDataUrl: '',
        formData: null,
    }),

    methods: {
        toggleShow() {
            this.show = !this.show;
        },

        handleChange(imgDataUrl, formData) {
            this.imgDataUrl = imgDataUrl;
            this.formData = formData;
            this.$emit('change', { imgDataUrl, formData });
        },

        handleReset() {
            this.$refs.uploader.off();
            this.handleChange('', null);
        },

        async base64ToFormData(base64Url) {
            const res = await fetch(base64Url);
            if (!res.ok || res.error) {
                return this.$awn.alert('Failed to fetch image data');
            }

            const blob = await res.blob();
            const file = new File([blob], this.file.name, { type: this.file.type });

            const formData = new FormData();
            formData.append('photo', file);

            return formData;
        },

        handleSrcFileSet(name, type, size) {
            this.file = { name, type, size };

            const ext = name.split('.').pop();
            if (!/^jpeg|jpg|png|bmp|webp$/i.test(ext)) {
                this.handleReset();
                return this.$awn.alert('Unsupported file type');
            }
        },

        async cropSuccess(imgDataUrl, field){
            const formData = await this.base64ToFormData(imgDataUrl);
            this.handleChange(imgDataUrl, formData);
        },

        cropUploadSuccess(jsonData, field){
            // Handling API calls ourselves from call point
            // this.$emit('uploadSuccess', jsonData);
        },

        cropUploadFail(status, field) {
            // Handling API calls ourselves from call point
            // this.$emit('uploadFail', status);
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.FormImageCropUpload {
    .input {
        display: flex;
        align-items: center;

        .Button {
            margin-left: 15px;
        }
    }

    .preview {
        width: 120px;
        height: 120px;
        border-radius: 50%;
        background-size: cover;
        background-position: center;
        background-color: $bg-color-4;
        overflow: hidden;
        position: relative;
        text-align: center;
        cursor: pointer;

        &:before {
            @include overlay();
            content: '';
            display: block;
            background-color: #000;
        }

        strong {
            @include absolute-center();
            color: #fff;
        }

        &:before, strong {
            opacity: 0;
            transition: opacity 100ms ease-in;
        }

        &:hover {
            &:before {
                opacity: 0.85;
            }

            strong {
                opacity: 1;
            }
        }
    }

    ::v-deep {
        .vicp-img {
            max-width: unset;
        }

        a, .vicp-operate-btn {
            font-weight: $font-weight-bold;
        }

        a {
            color: $button-primary-color !important;
        }

        .vicp-operate-btn {
            color: $link-color !important;
        }
    }
}
</style>
